import { ReactNode } from 'react'
import { getCrmLinkTariffTypeLabel } from './tariffTypes'
import cn from './createLinkBlockInfo.module.css'

type CreateLinkBlockInfoContentProps = {
  description?: string | null
  types: readonly string[]
}

/** Читаемый контент ишки: описание + список типов тарифов. */
export const CreateLinkBlockInfoContent = ({
  description,
  types,
}: CreateLinkBlockInfoContentProps): ReactNode => {
  const labels = types
    .map((type) => getCrmLinkTariffTypeLabel(type) ?? type)
    .filter(Boolean)

  if (!description && !labels.length) return null

  return (
    <div className={cn.root}>
      {description ? <div className={cn.description}>{description}</div> : null}
      {labels.length ? (
        <div className={cn.typesBlock}>
          <div className={cn.typesTitle}>Данная настройка доступна для следующих типов тарифов:</div>
          <ul className={cn.typesList}>
            {labels.map((label) => (
              <li key={label}>{label}</li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  )
}

export const getCreateLinkBlockTariffTypesHint = (
  types: readonly string[],
): ReactNode => <CreateLinkBlockInfoContent types={types} />

export const withCreateLinkBlockTariffTypesHint = (
  description: string,
  types: readonly string[],
): ReactNode => (
  <CreateLinkBlockInfoContent description={description} types={types} />
)
